import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import "./animations.css";
import Header from "./components/Header";
import Body from "./components/Body";
import About from "./components/About";
import EducationCard from "./components/Education";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WOW from "wowjs";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

function App() {
  useEffect(() => {
    // Initialize WOW.js with custom settings
    new WOW.WOW({
      live: false,
      offset: 100,
      duration: 1000,
      mobile: true,
      callback: function(box) {
        // Add custom animation class based on content type
        if (box.classList.contains('terminal-window')) {
          box.classList.add('animate__animated', 'animate__fadeIn');
        }
        if (box.classList.contains('command-line')) {
          box.classList.add('animate__animated', 'animate__slideInLeft');
        }
        if (box.classList.contains('skill-item')) {
          box.classList.add('animate__animated', 'animate__zoomIn');
        }
      }
    }).init();

    // Initialize AOS with custom settings
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      delay: 100,
      mirror: true,
      anchorPlacement: 'top-bottom',
    });
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <section id="home">
            <Body />
          </section>
          
          <section id="about" data-aos="fade-up" data-aos-duration="1000">
            <About />
          </section>
          
          <section id="education" data-aos="fade-up" data-aos-duration="1000">
            <EducationCard />
          </section>
          
          <section id="experience" data-aos="fade-left" data-aos-duration="1000">
            <Experience />
          </section>
          
          <section id="skills" data-aos="fade-right" data-aos-duration="1000">
            <Skills />
          </section>
          
          <section id="projects" data-aos="fade-up" data-aos-duration="1000">
            <Projects />
          </section>
          
          <section id="contact" data-aos="zoom-in" data-aos-duration="1000">
            <Contact />
          </section>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
